import { useEffect, useState } from "react";
import { Button, Modal, Form, Row, Col, Input, Select } from "antd";
import Moment from "react-moment";
import confirmBooking from "../../../../services/confirmBooking";
import fetchAllUsers from "../../../../services/fetchAllUsers";
const { Option } = Select;

export default function ConfirmCustomer({
  isVisible,
  selected,
  setConfirmModal,
  handleFetchBookings,
}: any) {
  const [form] = Form.useForm();
  const [users, setUsers] = useState<any>([]);

  const onSubmit = async () => {
    const { wip, assignedTo } = form.getFieldsValue();
    const data = {
      status: "Confirmed",
      name: selected?.customer_name,
      mobile: selected?.customer_mobile,
      wip,
      // assignedTo,
    };
    const booking_id = selected._id;
    const response = await confirmBooking(data, booking_id);
    setConfirmModal(false);
    await handleFetchBookings();
  };

  const hideModal = () => {
    setConfirmModal(false);
  };

  const handleFetchUsers = async () => {
    const response = await fetchAllUsers();
    const filtered = response?.payload.filter((item: any) => !item.isDealer);
    setUsers(response?.payload);
  };

  const userOptions = users.map((user: any, index: number) => (
    <Option value={user?._id} key={index}>
      {user?.firstname} {user?.lastname}
    </Option>
  ));

  useEffect(() => {
    form.resetFields();
    handleFetchUsers();
  }, [selected]);

  return (
    <Modal
      visible={isVisible}
      title="Confirm Booking"
      onCancel={hideModal}
      footer={[
        <Button key="back" onClick={hideModal}>
          Cancel
        </Button>,
        <Button
          key="submit"
          form="UpdateBooking"
          htmlType="submit"
          type="primary"
          onSubmit={onSubmit}
        >
          Confirm
        </Button>,
      ]}
    >
      <Form
        id="UpdateBooking"
        form={form}
        name="normal_login"
        className="login-form"
        onFinish={onSubmit}
      >
        <Row gutter={[16, 0]}>
          <Col xs={{ span: 24 }} lg={{ span: 24 }}>
            <Form.Item
              name="wip"
              rules={[
                {
                  required: true,
                  message: "Please enter WIP Number",
                },
              ]}
            >
              <Input placeholder="WIP / Booking Number" />
            </Form.Item>
          </Col>
        </Row>
        {/* <Row gutter={[16, 0]}>
          <Col xs={{ span: 24 }} lg={{ span: 24 }}>
            <Form.Item
              name="assignedTo"
              rules={[
                {
                  required: true,
                  message: "Please select assignee",
                },
              ]}
            >
              <Select placeholder="Assign To">{userOptions}</Select>
            </Form.Item>
          </Col>
        </Row> */}
        <div className="border py-4">
          <div className="flex justify-center items-center text-black font-bold text-lg">
            {selected?.contact?.customer?.name}
          </div>
          <div className="flex justify-center items-center text-lg">
            {selected?.vehicle?.registration}
          </div>
          <div className="flex justify-center items-center">
            <Moment format="Do MMM, YYYY">{selected?.date}</Moment>
          </div>
          <div className="flex justify-center items-center">
            <Moment format="HH:mm">{selected?.date}</Moment>
          </div>
        </div>
      </Form>
    </Modal>
  );
}
